// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { MenuList } from '../../../components'
import { isTenant } from '../../../utils/feature-flag-utils'

const HPEResourcesMenu = () => {
  const { t } = useTranslation(['common'])
  const navigate = useNavigate()
  const handleHPEResourcesMenuItemClick = (item) => {
    if (item.linkTo.includes('http')) {
      window.open(item.linkTo, '_blank')
    } else {
      navigate(item.linkTo)
    }
  }
  return (
    <MenuList
      navStyles={{
        padding: 'none',
        gap: 'none'
      }}
      menuData={[
        {
          id: 1,
          label: t('app_navigation.hpe_support_center'),
          testId: 'header-apps-hpe-support-center',
          linkTo: 'https://support.hpe.com/',
          isHidden: () => isTenant()
        },
        {
          id: 2,
          label: t('app_navigation.hpe_dev_community'),
          linkTo: 'https://developer.hpe.com/',
          testId: 'header-apps-hpe-developer-community'
        },
        {
          id: 3,
          label: t('app_navigation.hpe_communities'),
          linkTo: 'https://www.hpe.com/us/en/communities.html',
          testId: 'header-apps-hpe-communities'
        },
        {
          id: 4,
          label: t('app_navigation.hpe_financial_services'),
          linkTo: 'https://www.hpe.com/us/en/services/financial-services.html',
          testId: 'header-apps-hpe-financial-services'
        }
      ]}
      onClickMenuItem={handleHPEResourcesMenuItemClick}
      testId="hpe-resources-menu"
    />
  )
}

export { HPEResourcesMenu }
